<template>
  <InfuseModal
    :title="t('iam.users.machine_secret.title')"
    :disable-close="true"
  >
    <div class="flex flex-col gap-4">
      <InfuseNote type="warn">{{ t('iam.users.machine_secret.warning') }}</InfuseNote>

      <div class="flex flex-col gap-3 text-[0.8rem]">
        <div class="flex flex-col gap-1">
          <span class="font-semibold text-neutral-600">{{ t('iam.users.machine_secret.client_id_label') }}</span>
          <div class="flex items-center gap-2">
            <InfuseTag variant="primary" size="base" class="flex flex-row items-center rounded-lg bg-neutral-50 text-neutral-700">
              {{ user.externalId }}
            </InfuseTag>
            <InfuseCopy v-slot="scope">
              <font-awesome-icon
                class="cursor-pointer text-neutral-500 hover:text-neutral-600"
                :icon="['far', 'copy']"
                @click="scope.copy(user.externalId)"
              />
            </InfuseCopy>
          </div>
        </div>

        <div class="flex flex-col gap-1">
          <span class="font-semibold text-neutral-600">{{ t('iam.users.machine_secret.client_secret_label') }}</span>
          <div class="flex items-center gap-2">
            <InfuseTag variant="primary" size="base" class="flex flex-row items-center rounded-lg bg-neutral-50 font-mono text-neutral-700">
              {{ user.secret }}
            </InfuseTag>
            <InfuseCopy v-slot="scope">
              <font-awesome-icon
                class="cursor-pointer text-neutral-500 hover:text-neutral-600"
                :icon="['far', 'copy']"
                @click="scope.copy(user.secret || '')"
              />
            </InfuseCopy>
          </div>
        </div>
      </div>
    </div>

    <template #actions>
      <InfuseButton data-testid="modal-confirm-button" @click="emit('close')">
        {{ t('iam.users.machine_secret.confirm_button') }}
      </InfuseButton>
    </template>
  </InfuseModal>
</template>

<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { User } from '@infuse/iam/user/type';
import { InfuseButton, InfuseCopy, InfuseModal, InfuseNote, InfuseTag } from '@infuse/ui/components';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

defineProps<{
  user: User;
}>();

interface Emits {
  (event: 'close'): void;
}

const emit = defineEmits<Emits>();
</script>
